import apiClient from './index';
import qs from 'qs';

interface GeoJsonParams {
    selectedRows?: string[];
    campaignId?: string;
    selectedNetworkType: string;
    band: string;
    technology: 'lte' | 'nr' | '2.4' | '5' | '6';
    statistic: 'max' | 'mean';
    operator?: string;
    binSize?: string;
    geopolygon?: string;
}

// Add interface for the metadata response
interface CollectionMetadata {
    operators: string[];
    // lte and nr bands
    lte_bands: string[];
    nr_bands: string[];
    unii_bands?: string[];
    total_captures?: number;
}

interface CollectionMetadataParams {
    selectedRows?: string[];
    campaignId?: string;
}

export async function fetchGeoJson({
    selectedRows,
    campaignId,
    selectedNetworkType,
    band,
    technology,
    statistic,
    operator,
    binSize,
    geopolygon,
}: GeoJsonParams) {
    const params: any = {
        network_type: selectedNetworkType,
        band: band,
        technology,
        statistic,
        operator,
        bin_size: binSize,
        geopolygon: geopolygon,
    };

    if (campaignId) {
        params.campaign_id = campaignId;
    } else if (selectedRows && selectedRows.length > 0) {
        const sortedSelectedRows = [...selectedRows].sort();
        params.collection_ids = sortedSelectedRows;
    } else {
        throw new Error('Either selectedRows or campaignId must be provided');
    }

    const { data } = await apiClient.get('/sigcap/api/network-type-stats/', {
        params,
        paramsSerializer: (params) =>
            qs.stringify(params, {
                arrayFormat: 'comma',
                encodeValuesOnly: true,
                skipNulls: true,
                sort: (a, b) => a.localeCompare(b),
            }),
    });
    return data;
}

export async function fetchCollectionMetadata({
    selectedRows,
    campaignId,
}: CollectionMetadataParams): Promise<CollectionMetadata> {
    const params: any = {};

    if (campaignId) {
        params.campaign_id = campaignId;
    } else if (selectedRows && selectedRows.length > 0) {
        const sortedSelectedRows = [...selectedRows].sort();
        params.collection_ids = sortedSelectedRows;
    } else {
        throw new Error('Either selectedRows or campaignId must be provided');
    }

    const { data } = await apiClient.get('/sigcap/api/collection-meta/', {
        params,
        paramsSerializer: (params) =>
            qs.stringify(params, {
                arrayFormat: 'comma',
                encodeValuesOnly: true,
                skipNulls: true,
                sort: (a, b) => a.localeCompare(b),
            }),
    });
    return data;
}

